import React, { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import styles from "./Button.module.scss";
import { isMobile } from "react-device-detect";

export default function Button({ text, icon = null, action = null }) {
  const ctx = useContext(AppContext);
  const { toggleModal } = ctx;
  const shareDetails = { url: "#" };
  const handleSharing = async () => {
    if (isMobile) {
      if (navigator.share) {
        try {
          await navigator
            .share(shareDetails)
            .then(() =>
              console.log("Hooray! Your content was shared to the world")
            );
        } catch (error) {
          console.log(`Oops! I couldn't share to the world because: ${error}`);
        }
      } else {
        toggleModal(text);
      }
    } else {
      console.log(text, "TEXT");

      toggleModal(text);
    }
  };
  return (
    <div
      onClick={() => {
        console.log(text, "t");
        if (action) {
          action();
        } else if (
          text.toLowerCase() == "donate" ||
          text.toLowerCase() == "view on paras" ||
          text.toLowerCase() == "buy now" ||
          text.toLowerCase() == "mint nft" ||
          text.toLowerCase() == "place bid"
        ) {
          window.open(
            "https://paras.id/collection/kids-in-conflict-by-kidsinconflictnear",
            "_blank"
          );
        } else {
          handleSharing();
        }
      }}
      className={styles.wrapper}
    >
      {text}
      {icon && <span>{icon}</span>}
    </div>
  );
}
